import { useCallback } from "react";
import { useAppSelector } from "../services/hooks";
import { isSuperAdminByRoleId } from "../services/selectors/admin.selectors";
import {
  entitlementFeaturesSelector,
  featureUsageSelector,
  planNameSelector,
  trialSelector,
} from "../services/selectors/entitlements.selectors";
import {
  EntitlementsFeatureUsageDto,
  TFeatureKey,
} from "../services/types/users.types";

export function useEntitlements() {
  const features = useAppSelector(entitlementFeaturesSelector);
  const featureUsage = useAppSelector(featureUsageSelector);
  const planName = useAppSelector(planNameSelector);
  const trial = useAppSelector(trialSelector);
  // const isSuperAdmin = useAppSelector(isSuperAdminByRoleId);
 //temporary disable superadmin bypass
  // const hasFeature = useCallback(
  //   (key: TFeatureKey): boolean => isSuperAdmin || features.includes(key),
  //   [isSuperAdmin, features]
  // );
  const hasFeature = useCallback(
    (key: TFeatureKey): boolean => features.includes(key),
    [features]
  );

  const getFeatureUsage = useCallback(
    (key: TFeatureKey): EntitlementsFeatureUsageDto | undefined =>
      featureUsage.find((u) => u.feature === key),
    [featureUsage]
  );

  const isTrialReduced = useCallback(
    (key: TFeatureKey): boolean => getFeatureUsage(key)?.trialReduced ?? false,
    [getFeatureUsage]
  );
  
  return { hasFeature, getFeatureUsage, isTrialReduced, planName, trial };
}
